import { makeStyles } from '@mui/styles'

export const useStyles = makeStyles(({ palette, spacing }) => ({
  trust: {
    padding: spacing(4),
    // The Exclusive Content Paywall requires a different breakpoint for mobile
    // Any changes to this value should also be reflected in the index.js file
    '@media (max-width: 967px)': {
      padding: spacing(1),
      '@media (orientation: landscape)': {
        padding: spacing(0)
      }
    }
  },
  partners: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
    gap: spacing(2),
    marginBottom: spacing(6)
  },
  payment: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: spacing(2),
    gap: spacing(4),
    textAlign: 'right'
  },
  paymentDetails: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
  paymentOptions: {
    display: 'flex',
    flexDirection: 'row',
    gap: spacing(2)
  },
  paymentLogo: {
    backgroundColor: palette.grey[200],
    borderRadius: spacing(0.5),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '30px',
    width: '57px'
  },
  policies: {
    textAlign: 'right',
    fontSize: '0.875rem',
    // The Exclusive Content Paywall requires a different breakpoint for mobile
    // Any changes to this value should also be reflected in the index.js file
    '@media (max-width: 967px)': {
      textAlign: 'center'
    }
  }
}))
